import { parseISO, format as formatLocal } from 'date-fns';
import { format, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
export const formatToUtc = (timestamp, _format) => format(utcToZonedTime(parseISO(new Date(timestamp).toISOString()), 'UTC'), _format, {
    timeZone: 'UTC',
});
// mlp-ua-service sends submission timestamps as America/New_York wall-clock digits
// packaged as if they were a UTC epoch (see OGP-4132). Reinterpret those digits as
// Eastern to recover the true instant.
const toTrueInstant = (timestamp) => {
    const rawDate = new Date(timestamp);
    if (isNaN(rawDate.getTime())) {
        return null;
    }
    const easternWallClockIso = rawDate.toISOString().slice(0, -1);
    return zonedTimeToUtc(easternWallClockIso, 'America/New_York');
};
// Renders the recovered instant in the viewer's own local timezone.
export const formatEasternEpochAsLocal = (timestamp, _format) => {
    const trueInstant = toTrueInstant(timestamp);
    return trueInstant ? formatLocal(trueInstant, _format) : 'N/A';
};
// Test-only variant that lets specs pin a deterministic target zone instead of the
// test runner's local zone. Real callers should use formatEasternEpochAsLocal.
export const formatEasternEpochAsLocalInZone = (timestamp, _format, targetZone) => {
    const trueInstant = toTrueInstant(timestamp);
    return trueInstant ? format(utcToZonedTime(trueInstant, targetZone), _format, { timeZone: targetZone }) : 'N/A';
};
export const sortDatesByDateAndTime = (a, b) => {
    const aUTC = formatToUtc(a, "yyyy-MM-dd p");
    const bUTC = formatToUtc(b, "yyyy-MM-dd p");
    if (aUTC < bUTC)
        return -1;
    if (aUTC > bUTC)
        return 1;
    return 0;
};
